import LocalizedStrings from 'react-localization';

const data = new LocalizedStrings({
  en: {
    loadingMessage: 'One moment please...',
    nextPage: 'Next page',
    prevPage: 'Prev Page',
    enter: 'Enter',
    badServer: 'Could not connect to server',
    serverTimeout: 'Connection to server timed out.',
    objIdsQueryFail: 'Could not get OBJECTIDs from server',
    featureLayerUrl: 'Feature Layer URL',
    loadLayer: 'Load Layer',
    signIn: 'Sign In',
    enterpriseSignIn: 'Sign In to Enterprise',
    page: 'Page',
    of: 'of',
    rowsPerPage: 'Rows per page',
    editMode: 'Edit Mode',
    alpha: 'Alpha',
    alphaWarning: 'Alpha - use only on test data',
    cancel: 'Cancel',
    portalUrl: 'Portal URL',
    portalUrlTip:
      'The URL should include your web adaptor or webcontext, e.g. (https://myportal.mydomain.com/portal)',
    clientId: 'Client ID',
    clientIdTip:
      "Register an Application with your Enterprise Organization, then add https://esri.github.io to the Redirect URI's, then return here with the App ID from that item.",
  },
});
export type LocalStrings = typeof data;
export default data;
